import { useApi } from "../../../swr/useApi";
import { productDealTypesService } from "../../api_client";
import type { ProductDealTypeDto } from "../../../api";

export function useProductDealTypes() {
    return useApi<ProductDealTypeDto[]>("product-deal-types", async () => {
        return await productDealTypesService.getProductDealTypes();
    });
}


